import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './tailwind.css';
import App from './App.js';
import store from './redux/store.js'
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import reportWebVitals from './reportWebVitals';
import ReactPixel from 'react-facebook-pixel';

const pixelId = '295314976975757'; // Reemplaza con tu ID de Pixel

const options = {
  autoConfig: true, // Habilita la configuración automática
  debug: true, // Habilita el modo de depuración
};

ReactPixel.init(pixelId, undefined, options);
ReactPixel.pageView(); // Registrar una vista de página inicial
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
